export default __webpack_public_path__ + "static/media/logout.d4474bac.svg";